module.exports = __webpack_public_path__ + "4065e03d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/media_thestraitstimes@2x.png
// module id = 1198
// module chunks = 0